<div class="zen-ai-message" [ngClass]="{ 'user-message': message.isUser, 'ai-message': !message.isUser }">
  <div class="message-content">
    @if (message.formattedText && !message.isUser) {
      <div class="markdown-content" [innerHTML]="message.formattedText"></div>
    } @else {
      <p>{{ message.text }}</p>
    }
    @if (message.url && !message.isUser) {
      <a [href]="message.url" class="message-link" target="_blank" rel="noopener noreferrer"
        >View related violations →</a
      >
    }
  </div>
</div>
